import { NotificationSettingsRoutePaths } from "@app/applications/settings/domains/notification-settings/notification-settings-route-path";
import { ApplicationRoutePaths } from "@shared-core/routes/application-route-paths";

export abstract class QuotationNotificationSettingsRoutePaths extends ApplicationRoutePaths {
  static override readonly ROOT = `quotation-settings`;
  static readonly BASE_URL = `${NotificationSettingsRoutePaths.BASE_URL}/${this.ROOT}`;
}
